import s from "styled-components";
import { breakPoints } from "../index-styled";

export const Container = s.div`
  width: ${breakPoints.desktop.asideWidth};
  position: relative;
  background-color: var(--bg-paper);
  display: flex;
  flex-direction: column;
  height: ${breakPoints.desktop.size};
  @media(max-width: ${breakPoints.lg.bp}) {
    width: ${breakPoints.lg.asideWidth};
    height: ${breakPoints.lg.size};
  }
  @media(max-width: ${breakPoints.md.bp}) {
    width: ${breakPoints.md.asideWidth};
    height: ${breakPoints.md.size};
  }
  @media(max-width: ${breakPoints.sm.bp}) {
    width: 100%;
    height: auto;
    flex: 1;
  }
`;

export const ModeToggler = s.button`
  background-color: var(--color-primary);
  color: white;
  box-shadow: none;
  border: none;
  padding: 10px;
  font-weight: 500;
  margin-top: auto;
  outline: none;
  @media(max-width: ${breakPoints.sm.bp}) {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
  }
`;
